import {RequestModel} from "../../../request";
import {REQUEST} from "../../../requests.consts";
import {shareState} from "../../../../../app/share-state";

export class GetRequestGroupInfoModel extends RequestModel {
  constructor(requestParams) {
    super(REQUEST.CATEGORY.groups, REQUEST.ACTION.GROUPS.getGroupInfo, requestParams, false, true, false, false);

    this.apiEnvironment = shareState.environment.baseUrl;
    this.method = REQUEST.METHOD_TYPE.get;
  }
}
